import React from 'react';
import TimeSince from '../../TimeSince';
import './PostAuthor.css';
import { wallPostShape } from '../../../utils/shapes';

function PostAuthor({ post }) {
  return (
    <div className="feed-message-author-container">
      <div className="feed-message-author-name" title={post.author.displayName}>
        {post.author.displayName}
      </div>
      <div className="post-time">
        <TimeSince date={post.created} prefix="posted" />
      </div>
    </div>
  );
}

PostAuthor.propTypes = {
  post: wallPostShape
};

export default PostAuthor;



// WEBPACK FOOTER //
// ./src/components/FeedList/PostAuthor/index.js